import type { CountryCode } from '@src/common/auth';

/**
 * ISO 3166-1 alpha-3 country code. Any of the 229 codes in `data/countries.json` is valid,
 * so the type stays open — but the members of `CountryCode` (the ones that carry a business
 * rule) are surfaced for autocomplete. The `& Record<never, never>` keeps TypeScript from
 * collapsing the union into plain `string`, which is what `CountryCode | string` would do.
 */
export type Alpha3Code = CountryCode | (string & Record<never, never>);

export const FOREIGN_IDENTITY_TYPE = {
  IDENTITY: 'identity',
  PASSPORT: 'passport',
} as const;

export type ForeignIdentityType = (typeof FOREIGN_IDENTITY_TYPE)[keyof typeof FOREIGN_IDENTITY_TYPE];

export const IDENTITY_TYPE = {
  CPF: 'cpf',
  CNPJ: 'cnpj',
} as const;

export type IdentityType = (typeof IDENTITY_TYPE)[keyof typeof IDENTITY_TYPE];

export const AUTH_MODE = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot_password',
} as const;

export type AuthMode = (typeof AUTH_MODE)[keyof typeof AUTH_MODE];

export type IdentificationAuthMode = Exclude<AuthMode, typeof AUTH_MODE.FORGOT_PASSWORD>;

export const AUTH_OUTCOME = {
  COMPLETED: 'completed',
  NONE: 'none',
} as const;

export type AuthOutcome = { type: 'completed' } | { type: 'none' };
